<template>
  <div>
    <div class='commandes__faces-souhaitees'>
      <div class="card-article-label-faces-souhaitees">
        <b-field
          :label="$t('detail.article.facesSouhaitees')"
          custom-class="is-size-7 is-marginless has-text-link ellipsis">
          <b-field class="mgl-0">
            <template v-if="isLigneTypeProduitReseauTempo">
              <b-tooltip
                :active="!!this.ligneCommande.isAffecteLogistiquement"
                position="is-top"
                :label="$t('detail.article.facesSouhaiteesDisabled')"
                class="mgr-2">
                <b-input
                  v-model="ligneCommande.ligneReseau.qteFacesSouhaitees"
                  @input="onUpdateQteFaceSouhaitee"
                  :disabled="disabledInputQteFace"
                  custom-class="has-text-right"
                  type="number">
                </b-input>
              </b-tooltip>
              <div class="align-items: center">
                <span class="mgt-7px is-block no_wrap card-article-span-faces-dispo">
                  / {{ ligneCommande.ligneReseau.qteFacesPrevues }}
                </span>
              </div>
            </template>
            <template v-else-if="isLigneTypeProduitReseauLC">
              <b-input
                v-model="quantiteDispo"
                :disabled="disabled || ligneCommande.isAffecteLogistiquement"
                type="number">
              </b-input>
              <div class="align-items: center">
                <span class="mgt-7px is-block no_wrap card-article-span-faces-dispo">
                  %
                </span>
              </div>
            </template>
            <qd-button
              v-if="!isFacture"
              @click="popUpSelectionFace = true"
              :class="[ backgroundButtonSelection, { 'pointer-events-none' : !canMakeSelection}]"
              :disabled="!canMakeSelection || disabled"
              :loading="loadingReseauFacesSelected"
              class="buttonSelectFace is-relative">
              <b-icon type="is-white" icon="plus-circle" class="mgt-4px"></b-icon>
            </qd-button>
            <div v-else class="buttonSelectFace">
              <a
                v-if="ligneCommande.ligneReseau.lignesCmdSelProduits.length > 0"
                @click="popUpSelectionFace = true"
                :disabled="disabled"
                class="has-text-centered is-block">
                <b-icon icon="information" type="is-success" class="mgt-5px"></b-icon>
              </a>
            </div>
            <p v-if="!isFacture" class="has-text-icon-more mgl-5px is-size-7">
              {{ $t('detail.article.selectFace', { nbFace: getCountFacesSelected }) }}
            </p>
          </b-field>
        </b-field>
      </div>
      <app-spec-produit-associe-location
        v-if="hasLocation"
        @updatePeriodeLocation="updatePeriodeLocation"
        :disabled="disabled || ligneCommande.isAffecteLogistiquement"
        :ligneRegroupement="ligneCommande"
        :ouverturePopup= "ouverturePopup"
        :devisCommande="devisCommande"
        class="dates-regroupement mgt-28px"
      />
    </div>
    <div
      v-if="ligneCommande.ligneReseau.anneeSemaine">
      <qd-switch
        v-model="ligneCommande.tarifUnitaire"
        @input="toggleTarifUnitaire"
        :disabled="disabled"
        class="has-text-icon-more mgt-5px">
        {{$t('detail.article.tarifUnitaire')}}
      </qd-switch>
    </div>
    <b-modal
      v-model="popUpSelectionFace"
      width="1400px"
      class="modal"
      has-modal-card>
      <pop-up-selection-face
        @updateLignesCmdSelProduits="updateLignesCmdSelProduits"
        @updateLignesCmdSelOptionProduits="updateLignesCmdSelOptionProduits"
        @updateTlpe="updateTlpe"
        :display-column-logistique="typeDcf === TYPE_COMMANDE"
        :ligne-select="ligneCommande"
        :devis-commande= "devisCommande"
        :permissions="permsDcf"
        :is-detail="isFacture"
        :typeDcf="typeDcf">
      </pop-up-selection-face>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import initialisationOptionBlocage from '@/services/devisCommandes/optionBlocage/initialisationOptionBlocage';
import {
  CATEGORIE_REGROUPEMENT_LC,
  CATEGORIE_REGROUPEMENT,
  CATEGORIE_LOCATION,
  CATEGORIE_DIVERS,
} from '@/configuration/catalogue/produitConf';
import popUpSelectionFace from '@/components/devisCommandeFacture/facesSelectInReseauTempo/p_selectFaces';
import { BLOQUE, OPTION, BLOQUE_COMMANDE } from '@/configuration/optionBlocage/optionBlocage';
import { TYPE_DEVIS, TYPE_FACTURE, TYPE_COMMANDE } from '@/configuration/devisConf';
import { FACTURES, DEVIS, COMMANDES } from '@/configuration/permissionsBodacConf';
import calculTlpe from '@/services/dcf/tlpe/calculTlpe';
import appSpecProduitAssocieLocation from '@/components/devisCommandes/editionDevisCommande/specLigneArticle/produitAssociesLocation';
import * as gestionTarifUnitaire from '@/services/devisCommandes/ligneCommande/gestionTarifUnitaire';
import estDemandeManuelle from '@/services/devisCommandes/estDemandeManuelle';
import debounce from 'lodash/debounce';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    ligneCommande: Object,
    isLigneRegroupementReseauInCreateCommandeFromDevis: Boolean,
    typeDcf: {
      type: String,
      required: true,
    },
    ouverturePopup: Boolean,
    devisCommande: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    periodeTotalCalculTlpeAuto: {
      type: Boolean,
      required: true,
    },
    loadingReseauFacesSelected: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    popUpSelectionFace,
    appSpecProduitAssocieLocation,
  },
  data() {
    return {
      popUpSelectionFace: false,
      TYPE_COMMANDE: TYPE_COMMANDE,
      produitRegroupement: CATEGORIE_REGROUPEMENT,
      quantiteSouhaiteBase: null,
      quantiteDispo: this.ligneCommande.quantiteDispo * 100,
    };
  },
  watch: {
    quantiteDispo(newQuantiteDispo) {
      if (newQuantiteDispo < 0) {
        this.ligneCommande.quantiteDispo = 0;
        this.quantiteDispo = 0;
      } else {
        this.ligneCommande.quantiteDispo = newQuantiteDispo / 100;
        this.$emit('calculAutoTlpe');
      }
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    isFacture() {
      return (this.typeDcf === TYPE_FACTURE);
    },
    isDevis() {
      return (this.typeDcf === TYPE_DEVIS);
    },
    hasLocation() {
      return this.ligneCommande.lignesCommande.some((ligneEnfant) => {
        return ligneEnfant.typeProduit === CATEGORIE_LOCATION;
      });
    },
    backgroundButtonSelection() {
      if (!this.canMakeSelection) return 'has-background-forbidden';
      return (this.getCountFacesSelected === 0)
        ? 'has-background-primary' : 'has-background-success';
    },
    canMakeSelectionForEtatBloque() {
      return (this.ligneCommande.etatSouhaite === BLOQUE && this.ligneCommande.etatDeLaDemande)
        || [BLOQUE].includes(this.ligneCommande.etatObtenu) || this.typeDcf === TYPE_COMMANDE;
    },
    canMakeSelectionForEtatOption() {
      return this.ligneCommande.etatSouhaite === OPTION && this.isDevis;
    },
    canMakeSelection() {
      return !!(!this.isFacture
        && this.ligneCommande.ligneReseau
        && (this.canMakeSelectionForEtatBloque || this.canMakeSelectionForEtatOption
        || this.typeDcf === TYPE_COMMANDE)) && !this.loadingReseauFacesSelected;
    },
    getCountFacesSelected() {
      let count = 0;
      if (this.canMakeSelectionForEtatBloque) {
        count = this.ligneCommande.ligneReseau.lignesCmdSelProduits.length;
      }
      if (this.canMakeSelectionForEtatOption && count === 0) {
        count = this.ligneCommande.lignesCmdSelOptionProduit
          ? this.ligneCommande.lignesCmdSelOptionProduit.length : 0;
      }
      return count;
    },
    permsDcf() {
      switch (this.typeDcf) {
        case TYPE_COMMANDE:
          return COMMANDES;
        case TYPE_FACTURE:
          return FACTURES;
        default:
          return DEVIS;
      }
    },
    disabledInputQteFace() {
      return this.isLigneRegroupementReseauInCreateCommandeFromDevis || this.disabled
        || !!this.ligneCommande.isAffecteLogistiquement
        || this.isLigneLocationOfReseauInDevisWithValidationModifBlocage;
    },
    isLigneTypeProduitReseauTempo() {
      return this.ligneCommande.typeProduit === CATEGORIE_REGROUPEMENT;
    },
    isLigneTypeProduitReseauLC() {
      return this.ligneCommande.typeProduit === CATEGORIE_REGROUPEMENT_LC;
    },
    interdireModificationBlocageCLGActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.interdireModificationBlocageCLG.key);
    },
    isLigneLocationOfReseauInDevisWithValidationModifBlocage() {
      return (estDemandeManuelle() && this.interdireModificationBlocageCLGActive
        && this.ligneCommande.id
        && [TYPE_DEVIS, TYPE_COMMANDE].includes(this.devisCommande.type)
        && this.ligneCommande.typeProduit === CATEGORIE_REGROUPEMENT
        && [BLOQUE, BLOQUE_COMMANDE].includes(this.ligneCommande.etatObtenu));
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    onUpdateQteFaceSouhaitee: debounce(function updateInfo() {
      this.updateStatusOptionBlocage();
      gestionTarifUnitaire.onUpdateQteFaceSouhaitee(this.ligneCommande);
      if (this.quantiteSouhaiteBase !== this.ligneCommande.ligneReseau.qteFacesSouhaitees) {
        this.$emit('reloadSimulationEtatProv');
      }
      this.updateQteFaceLocation(this.ligneCommande);
      this.$emit('reloadTotalHt');
    }, 500),
    toggleTarifUnitaire() {
      gestionTarifUnitaire.toggleTarifUnitaire(this.ligneCommande);
      this.$emit('reloadTotalHt');
    },
    async updateStatusOptionBlocage() {
      initialisationOptionBlocage(this.ligneCommande);
      await this.updateTlpe(this.ligneCommande);
      this.$emit('reloadTotalHt');
    },
    async updateTlpe(ligne) {
      try {
        await calculTlpe(
          ligne,
          this.isFacture,
          this.periodeTotalCalculTlpeAuto,
          this.devisCommande.repartitionPayeurSurFacture,
        );
      } catch (e) {
        ligne.lignesCommande.forEach((el) => {
          if (el.typeProduit === CATEGORIE_DIVERS && el.calculAutomatiqueTlpe
            && el.produit.produitDivers.tlpe) {
            el.prixUnitaire = 0;
          }
        });
      }
    },
    updatePeriodeLocation(eventArgument) {
      this.$emit('updatePeriodeLocation', eventArgument);
    },
    updateQteFaceLocation(ligneCommande) {
      ligneCommande.lignesCommande.forEach(ligneEnfant => {
        if (ligneEnfant.typeProduit === CATEGORIE_LOCATION
            && ligneCommande.typeProduit === CATEGORIE_REGROUPEMENT) {
          ligneEnfant.ligneReseau.qteFacesSouhaitees = Math.floor(
            ligneCommande.ligneReseau.qteFacesSouhaitees,
          );
        }
      });
    },
    updateLignesCmdSelProduits(data, ligneSelected) {
      ligneSelected.ligneReseau.lignesCmdSelProduits = data;
    },
    updateLignesCmdSelOptionProduits(data, ligneSelected) {
      ligneSelected.lignesCmdSelOptionProduit = data;
    },
  },
  async mounted() {
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.interdireModificationBlocageCLG.key,
      ]);
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    }
    if (!this.ligneCommande.ligneReseau.qteFacesPrevues) {
      this.ligneCommande.ligneReseau.qteFacesPrevues = 0;
    }
    if (!this.ligneCommande.ligneReseau.qteFacesSouhaitees) {
      this.ligneCommande.ligneReseau.qteFacesSouhaitees = 0;
    }
    this.quantiteSouhaiteBase = this.ligneCommande.ligneReseau.qteFacesSouhaitees;
    this.$emit('reloadTotalHt');
  },
};
</script>

<style scoped>

</style>
